export default __webpack_public_path__ + "static/media/noImage.298b9820.png";